export const styles = {
  subFormViewerPaper: {
    marginTop: '30px',
  },
  backToParentFormButton: {
    marginTop: '10px',
    marginLeft: '10px',
  },
};
